import { apiRequestWithChecks } from "./api";

export const payment = {
  getPaymentMethods(token) {
    return apiRequestWithChecks("GET", "/api/payment/payment-methods", {
      Authorization: "Bearer " + token,
    });
  },
  addPaymentMethod(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/payment/add-payment-method",
      { Authorization: "Bearer " + token },
      data
    );
  },
  updatePaymentMethod(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/payment/update-payment-method",
      { Authorization: "Bearer " + token },
      data
    );
  },
};
